export const _metrics = [
    "coverage",
    "duplicated_lines_density",
    "ncloc",
    "alert_status",
    "security_hotspots",
    "bugs",
    "code_smells",
    "vulnerabilities",
    "sqale_rating",
    "reliability_rating",
    "security_rating",
    "sqale_index",
    "software_quality_reliability_issues",
    "software_quality_maintainability_issues",
    "software_quality_security_issues",
    "software_quality_maintainability_rating",
    "software_quality_reliability_rating",
    "software_quality_security_rating",
    "software_quality_maintainability_remediation_effort"
  ];


  export const _projectLinks: Record<string, string> = {
    "gt699": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Ascience-gt669&codeScope=overall",
    "cosigua": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Aotm-cosigua&codeScope=overall",
    "diaco": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Ascience_gerdau_diaco_optimization&codeScope=overall",
    "caster-scheduler": "https://sonarqube.enacloud.me/dashboard?id=science_caster_scheduler&codeScope=overall",
    "rolling_ob_twin": "https://sonarqube.enacloud.me/code?id=enacom%3Ascience_rolling_ob_twin&codeScope=overall",
    "pbt-rolling": "https://sonarqube.enacloud.me/dashboard?id=otm-longos-pbt-app&codeScope=overall",
    "longos": "https://sonarqube.enacloud.me/dashboard?id=otm-longos-pbt-app&codeScope=overall",
    "strip-rolling-ob-twin": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Ascience_profile_rolling_ob_twin&codeScope=overall",
    "gerdau-yard-optimization": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Ascience_gerdau_yard_optimization&codeScope=overall",
    "vli-gateway": "https://sonarqube.enacloud.me/dashboard?id=enacom%3Ascience_vli_gateway_v2&codeScope=overall",
  };